import { jsx as _jsx } from "react/jsx-runtime";
import { FieldWrapper, InputText } from '@dixa/lib-shared-habla';
import { useHookFormFieldWrapper, } from 'utils/hookForm';
/** Represents the React Hook Form variant of the {@link InputText} component. */
export const HookFormText = (props) => {
    const { controller, controllerProps, fieldWrapperProps } = useHookFormFieldWrapper(props);
    return (_jsx(FieldWrapper, Object.assign({}, fieldWrapperProps, { children: _jsx(InputText, Object.assign({}, props.componentProps, controller.field, { onBlur: (event) => {
                var _a, _b;
                (_b = (_a = props.componentProps) === null || _a === void 0 ? void 0 : _a.onBlur) === null || _b === void 0 ? void 0 : _b.call(_a, event);
                controller.field.onBlur();
            }, onChange: (event) => {
                var _a, _b;
                (_b = (_a = props.componentProps) === null || _a === void 0 ? void 0 : _a.onChange) === null || _b === void 0 ? void 0 : _b.call(_a, event);
                controller.field.onChange(event);
            }, id: controllerProps.name, "aria-disabled": fieldWrapperProps.disabled, disabled: fieldWrapperProps.disabled, "aria-required": fieldWrapperProps.required, required: fieldWrapperProps.required, status: FieldWrapper.getStatus(fieldWrapperProps.meta) })) })));
};
